export default "__VITE_ASSET__BdcZdn7X__"